import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "../../Common/FormElements/Select/Select";
import Button from "../../Common/FormElements/Button/Button";
import { acceptQuoteForCustomer } from "../../../REDUX/actions/appProjects";
import { closeCenteredModal } from "../../../REDUX/actions/centeredModal";

// The note is stored in French (it is quoted in the project Discussion).
const NOTES = [
  { label: "Phone", note: "Téléphone" },
  { label: "Signed in store", note: "Signé en magasin" },
  { label: "Other", note: "Autre" },
];

/** ⋮ "Marquer comme accepté hors app" (rule 5): phone, paper, e-mail… */
const AcceptOfflineModal = ({ projectId, quoteId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const options = NOTES.map(({ label, note }) => ({ name: t(label), code: note }));
  const [note, setNote] = useState(options[0]);
  const close = () => dispatch(closeCenteredModal());

  return (
    <div className="p-4 bg-white br10" style={{ minWidth: 420 }}>
      <h3 className="text-blue bold f18 quickSand mb-3">
        {t("Mark as accepted outside the app")}
      </h3>
      <label className="f16 text-softBlack sBold mb-1">{t("Acceptance note")}</label>
      <Select
        options={options}
        value={note}
        callback={(e) => setNote(e.value ?? null)}
        appendToSelf
      />
      <div className="d-flex justify-content-end gap-3 mt-4">
        <Button variant="outline" onClick={close}>
          {t("Cancel")}
        </Button>
        <Button
          disabled={!note}
          onClick={() =>
            dispatch(acceptQuoteForCustomer(projectId, quoteId, note?.code, t, close))
          }
        >
          {t("Validate")}
        </Button>
      </div>
    </div>
  );
};

export default AcceptOfflineModal;
